import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Container, Row, Col, Modal, Button } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { SlCalender } from "react-icons/sl";
import { FaIndianRupeeSign } from "react-icons/fa6";

function Rooms() {
  // const Rooms = [
  //   {
  //     id: 1,
  //     name: "Cottage A",
  //     description:
  //       "A luxurious room with a king-sized bed, private balcony, and ocean view.",
  //     standardOccupancy: 2,
  //     extraPerson: 1,
  //     pricePerNight: 12000,
  //     image: "https://via.placeholder.com/150",
  //   },
  //   {
  //     id: 2,
  //     name: "Cottage B",
  //     description:
  //       "A spacious suite with a separate living area, modern amenities, and city views.",
  //     standardOccupancy: 2,
  //     extraPerson: 1,
  //     pricePerNight: 12000,
  //     image: "https://via.placeholder.com/150",
  //   },
  //   {
  //     id: 3,
  //     name: "suite A",
  //     description:
  //       "Ideal for families, featuring two double beds and a comfortable lounge area.",
  //     standardOccupancy: 2,
  //     extraPerson: 4,
  //     pricePerNight: 18000,
  //     image: "https://via.placeholder.com/150",
  //   },
  //   {
  //     id: 4,
  //     name: "Suite B",
  //     description:
  //       "A cozy room with all essential amenities, suitable for solo travelers.",
  //     standardOccupancy: 2,
  //     extraPerson: 3,
  //     pricePerNight: 18000,
  //     image: "https://via.placeholder.com/150",
  //   },
  //   {
  //     id: 5,
  //     name: "Suite C",
  //     description:
  //       "An exclusive suite with panoramic views, private terrace, and premium amenities.",
  //     standardOccupancy: 4,
  //     extraPerson: 7,
  //     pricePerNight: 36000,
  //     image: "https://via.placeholder.com/150",
  //   },
  //   {
  //     id: 6,
  //     name: "Studio",
  //     description:
  //       "An exclusive suite with panoramic views, private terrace, and premium amenities.",
  //     standardOccupancy: 2,
  //     extraPerson: 1,
  //     pricePerNight: 9600,
  //     image: "https://via.placeholder.com/150",
  //   },
  //   {
  //     id: 7,
  //     name: "Villa",
  //     description:
  //       "An exclusive suite with panoramic views, private terrace, and premium amenities.",
  //     standardOccupancy: 10,
  //     extraPerson: 15,
  //     pricePerNight: 81600,
  //     image: "https://via.placeholder.com/150",
  //   },
  //   {
  //     id: 8,
  //     name: "Full Exclusive Estate**",
  //     description:
  //       "An exclusive suite with panoramic views, private terrace, and premium amenities.",
  //     standardOccupancy: 14,
  //     extraPerson: 17,
  //     pricePerNight: 105600,
  //     image: "https://via.placeholder.com/150",
  //   },
  // ];

  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const program = searchParams.get("program");
  const programId = searchParams.get("programId");
  const duration = parseInt(searchParams.get("duration"));
  const initialStartDate = searchParams.get("startDate");
  const initialEndDate = searchParams.get("endDate");
  const totalProgramPrice = parseInt(searchParams.get("totalPrice"));

  const [showModal, setShowModal] = useState(false);
  const [guestCount, setGuestCount] = useState(1);
  const [extraPerson, setExtraPerson] = useState();
  const [startDate, setStartDate] = useState(new Date(initialStartDate));
  const [endDate, setEndDate] = useState(new Date(initialEndDate));
  const [totalPrice, setTotalPrice] = useState({});
  const [selectedRoom, setSelectedRoom] = useState(null);
  const [bookingDetails, setBookingDetails] = useState(null);
  const [isRoomSelected, setIsRoomSelected] = useState(false);

  const handleOpenModal = (room) => {
    setGuestCount(1);
    setSelectedRoom(room);
    setShowModal(true);
  };
 

  useEffect(() => {
    // Load selected room and total price from localStorage if it exists
    const savedSelectedRoom = JSON.parse(localStorage.getItem("selectedRoom"));
    const savedIsRoomSelected = localStorage.getItem("isRoomSelected");
    const savedTotalPrice = JSON.parse(localStorage.getItem("totalPrice"));

    if (savedSelectedRoom) {
      setSelectedRoom(savedSelectedRoom);
    }
    if (savedIsRoomSelected) {
      setIsRoomSelected(savedIsRoomSelected);
    }
    if (savedTotalPrice) {
      setTotalPrice(savedTotalPrice);
    }
  }, []);

  useEffect(() => {
    const prices = {};
    Rooms.forEach((room) => {
      prices[room.id] = calculateTotalPrice(room.pricePerNight);
    });
    setTotalPrice(prices);
  }, [duration, totalProgramPrice]);


  useEffect(() => {
    // Save selected room and total price to localStorage whenever they change
    localStorage.setItem("selectedRoom", JSON.stringify(selectedRoom));
    localStorage.setItem("isRoomSelected", isRoomSelected);
    localStorage.setItem("totalPrice", JSON.stringify(totalPrice));
  }, [selectedRoom, isRoomSelected, totalPrice]);


  const handleCloseModal = () => setShowModal(false);

  const handleIncreaseGuest = () => {
    if (selectedRoom) {
      setGuestCount((prevCount) => Math.min(prevCount + 1, selectedRoom.totalOccupancyCapacity));
    }
  };

  const handleDecreaseGuest = () => {
    if (selectedRoom) {
      setGuestCount((prevCount) => Math.max(prevCount - 1, 1));
    }
  };

  useEffect(() => {
    if (selectedRoom) {
    const total = guestCount - selectedRoom.standardOccupancy;
    setExtraPerson(total)
    }
  }, [guestCount]);

  const calculateTotalPrice = (roomPrice) => {
    const roomCost = roomPrice * duration;
    return totalProgramPrice + roomCost;
  };

  useEffect(() => {
    const prices = {};
    Rooms.forEach((room) => {
      prices[room.id] = calculateTotalPrice(room.pricePerNight);
    });
    setTotalPrice(prices);
  }, [duration, totalProgramPrice]);


  const formattedStartDate = startDate.toLocaleDateString("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
    year: "numeric",
  });

  const formattedEndDate = endDate.toLocaleDateString("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
    year: "numeric",
  });

  
  const handleBookNow = (roomId) => {
    if (selectedRoom) {
      const totalBill = totalPrice[selectedRoom.id];
      const details = {
        program,
        programId,
        roomName: selectedRoom.name,
        roomId:selectedRoom.id,
        startDate: formattedStartDate,
        endDate: formattedEndDate,
        duration,
        guestCount,
        extraPerson,
        totalBill,
      };
      setBookingDetails(details);
      setIsRoomSelected(roomId);
      setSelectedRoom(Rooms.find(room => room.id === roomId));  // Find the selected room

    }
  };

  const handleProceedToPay = () => {
    if (bookingDetails) {
      const queryParams = new URLSearchParams(bookingDetails).toString();
      navigate(`/bookingdetails?${queryParams}`);
    }
  };

  return (
    <>
      <div className="rooms-page">
        <div className="coverimg">
          <img src="https://img.freepik.com/free-photo/aerial-shot-tropical-beach-sri-lanka-perfect-family-vacation_181624-8146.jpg?ga=GA1.1.1586153261.1719654350&semt=ais_hybrid" alt="Cover" />
        </div>
        <Container className="py-5">
          <Row className="g-4">
            <Col sm={8}>
              <Row className="d-flex align-items-stretch">
                <Col sm={6} className="p-2">
                  <div className="booking-dates p-3 d-flex align-items-center gap-4">
                    <SlCalender className="bookingicons" />
                    <div className="dates-text">
                      <p className="mb-2"><strong>Start Date</strong></p>
                      <DatePicker selected={startDate} onChange={setStartDate} dateFormat="MMMM d, yyyy" className="form-control date-box rounded-0 border-0 py-2 px-4" />
                    </div>
                  </div>
                </Col>
                <Col sm={6} className="p-2">
                  <div className="booking-dates p-3 d-flex align-items-center gap-4">
                    <SlCalender className="bookingicons" />
                    <div className="dates-text">
                      <p className="mb-2"><strong>End Date</strong></p>
                      <DatePicker selected={endDate} onChange={setEndDate} dateFormat="MMMM d, yyyy" className="form-control date-box rounded-0 border-0 py-2 px-4" />
                    </div>
                  </div>
                </Col>
              </Row>

              <h4 className="mt-4 rooms-title">Select A Room</h4>
              <Row>
                <Col sm={12}>
                  {Rooms.map((room) => (
                    <div key={room.id} className="d-flex p-3 w-100 gap-3 room-box my-3">
                      <div className="room-img"><img src={room.image} alt={room.name} /></div>
                      <div className="d-flex align-items-center justify-content-between room-content gap-3">
                        <div className="w-50">
                          <h4 className="pb-1 room-name">{room.name}</h4>
                          <div className="d-flex gap-3 small-text">
                            <small>Standard Occupancy: {room.standardOccupancy}</small>
                            <small>Total Occupancy Capacity: {room.totalOccupancyCapacity}</small>
                          </div>
                          <p className="room-description">{room.description}</p>
                        </div>
                        <div className="text-end">
                          <h4 className="room-price"><FaIndianRupeeSign />{totalPrice[room.id]}</h4>
                          <small className="small-text">Per Day (up to standard occupancy)</small>
                          <div className="d-flex gap-3 pt-3">
                            <Button className="rounded-0 border-0 guest-btn px-4 py-2" onClick={() => handleOpenModal(room)}>Select Guests</Button>
                            <Button 
                              className="rounded-0 border-0 book-btn px-4 py-2" 
                              onClick={() => handleBookNow(room.id)}
                            >
                              {isRoomSelected === room.id ? "Keep Room" : "Book Now"}
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </Col>
              </Row>
            </Col>

            <Col sm={4} className="p-2">
              <div className="totalprice p-5">
                {bookingDetails ? (
                  <div>
                    <h4>{bookingDetails.roomName}</h4>
                    <span>{bookingDetails.program}</span>  
                    <h5 className="pt-3"><strong>{bookingDetails.duration} days Stay</strong></h5>            
                    <p><strong>{bookingDetails.startDate} - {bookingDetails.endDate}</strong></p>
                    <p><strong>{bookingDetails.guestCount} Guests</strong></p>
                    <hr />
                    <h4><strong>Total <FaIndianRupeeSign />{bookingDetails.totalBill}</strong></h4>
                    <Button className="rounded-0 border-0 proceed-btn px-4 py-2 mt-3" onClick={handleProceedToPay}>Proceed to Pay</Button>
                  </div>
                ) : (
                  <h4>Total  <FaIndianRupeeSign />0</h4>
                )}
              </div>
            </Col>
          </Row>
        </Container>

        <Modal show={showModal} onHide={handleCloseModal} centered className="rooms-modal">
          <Modal.Body className="modal-body p-md-5 p-3 rounded-0">
            <Modal.Title className="modal-title pb-3">Select Number of Guests</Modal.Title>
            <div className="d-flex align-items-center justify-content-between">
              <Button className="addbtn border-0 rounded-0" onClick={handleDecreaseGuest} disabled={guestCount <= selectedRoom?.standardOccupancy}>-</Button>
              <span className="px-3 guestcount"><h4>{guestCount}</h4></span>
              <Button className="addbtn border-0 rounded-0" onClick={handleIncreaseGuest} disabled={!selectedRoom || guestCount >= selectedRoom.totalOccupancyCapacity}>+</Button>
            </div>
             
            <Button className="addbtn border-0 rounded-0 mt-3 px-4 py-2" onClick={handleCloseModal}>Done</Button>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
}

export default Rooms;
